import React from "react";

// Bolinha da cor da etiqueta (Tags.cor), usada nos seletores de etiqueta.
// Etiqueta antiga não tem cor: aí some a bolinha em vez de desenhar um ponto
// preto, que pareceria uma cor escolhida.
const PontoCorEtiqueta = ({ cor, style }) => {
	if (!cor) return null;

	return (
		<span
			style={{
				display: "inline-block",
				width: 10,
				height: 10,
				borderRadius: "50%",
				backgroundColor: cor,
				marginRight: 8,
				flexShrink: 0,
				...style,
			}}
		/>
	);
};

export default PontoCorEtiqueta;
